import {
  IgNumericalCounter,
  IgSwitch,
  IgTypography,
} from "@intelligems/ig-theme";
import Stack from "@mui/material/Stack";

import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";

interface GeneralSectionProps {
  maxProducts: number;
  excludeOutOfStock: boolean;
  excludeItemsInCart: boolean;
  onChange: (changes: {
    maxProducts?: number;
    excludeOutOfStock?: boolean;
    excludeItemsInCart?: boolean;
  }) => void;
}

// Product-selection settings, shown above the rules.
export const GeneralSection = ({
  maxProducts,
  excludeOutOfStock,
  excludeItemsInCart,
  onChange,
}: GeneralSectionProps) => (
  <Stack spacing={3}>
    <Panel.Header>General</Panel.Header>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <IgTypography>Exclude out of stock items</IgTypography>
      <IgSwitch
        checked={excludeOutOfStock}
        onChange={(_, checked) => onChange({ excludeOutOfStock: checked })}
      />
    </Stack>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <IgTypography>Exclude products in cart</IgTypography>
      <IgSwitch
        checked={excludeItemsInCart}
        onChange={(_, checked) => onChange({ excludeItemsInCart: checked })}
      />
    </Stack>
    <IgNumericalCounter
      label="Number of products to show"
      value={maxProducts}
      min={1}
      max={10}
      onChange={(value) => value != null && onChange({ maxProducts: value })}
    />
  </Stack>
);
